import { render, staticRenderFns } from "./CoverGenius.vue?vue&type=template&id=12fd5568&scoped=true&"
import script from "./CoverGenius.vue?vue&type=script&lang=ts&"
export * from "./CoverGenius.vue?vue&type=script&lang=ts&"
import style0 from "./CoverGenius.vue?vue&type=style&index=0&id=12fd5568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd5568",
  null
  
)

export default component.exports